import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "text",
        options: {
          data: "Male voice",
          scrollbars: false,
        },
      },
      styles: {
        justifyContent: "flex-start",
        fontSize: "12px",
        fontWeight: 700,
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          icon: "cis-volume-high",
          theme: "primary",
          text: "original",
          shape: "round",
          size: "small",
          url: `${config.ASSETS_URL}/05/23/principle/original-male.wav`,
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          icon: "cis-volume-high",
          theme: "primary",
          text: "62",
          shape: "round",
          size: "small",
          url: `${config.ASSETS_URL}/05/23/principle/62-massive-male.wav`,
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          icon: "cis-volume-high",
          theme: "primary",
          text: "58",
          shape: "round",
          size: "small",
          url: `${config.ASSETS_URL}/05/23/principle/58-massive-male.wav`,
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          icon: "cis-volume-high",
          theme: "primary",
          text: "54",
          shape: "round",
          size: "small",
          url: `${config.ASSETS_URL}/05/23/principle/54-massive-male.wav`,
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          icon: "cis-volume-high",
          theme: "primary",
          text: "50",
          shape: "round",
          size: "small",
          url: `${config.ASSETS_URL}/05/23/principle/50-massive-male.wav`,
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          icon: "cis-volume-high",
          theme: "primary",
          text: "46",
          shape: "round",
          size: "small",
          url: `${config.ASSETS_URL}/05/23/principle/46-massive-male.wav`,
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          icon: "cis-volume-high",
          theme: "primary",
          text: "42",
          shape: "round",
          size: "small",
          url: `${config.ASSETS_URL}/05/23/principle/42-massive-male.wav`,
        },
      },
    },
  },
];

export default components;
